import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import {
	fluidValues,
	flexGapPolyfill,
	fontStyle,
} from '@/css/resources/mixins.css';
import { resetFirstLastChildMargins } from '@/css/resources/placeholders.css';

const getDynamicStyles = (styles) =>
	cssObj(
		fluidValues(
			'marginTop',
			styles?.margin?.top?.[0],
			styles?.margin?.top?.[1]
		),
		fluidValues(
			'marginBottom',
			styles?.margin?.bottom?.[0],
			styles?.margin?.bottom?.[1]
		),
		{
			'.supt-listCards__title': fontStyle({
				...styles?.title?.typography,
				textAlign: styles?.title?.textAlignment,
				color: styles?.title?.color,
			}),

			'> .supt-listCards__list': flexGapPolyfill(
				styles?.grid?.gap,
				styles?.grid?.gap,
				styles?.margin?.top
			),
		}
	);

const getStyles = (styles) =>
	css(getDynamicStyles(styles), resetFirstLastChildMargins, {
		'> .supt-listCards__list': {
			display: 'flex',
			flexWrap: 'wrap',
		},
	});

export { getStyles };
